import { useState } from 'react';
import { WbInput, WbText } from '@workbench/react';

/**
 * Text/password input on top of `wb-input`. Supports both controlled (`val` +
 * `onChange`) and uncontrolled (`defaultValue` + `getValue`) usage.
 */
function VimdtInput({
	label,
	password = false,
	defaultValue = '',
	getValue,
	disabled = false,
	val,
	name,
	onChange,
	message,
	setType,
	setId,
	className,
	testId,
}) {
	const [value, setValue] = useState(defaultValue);
	const currentValue = val !== undefined && val !== null ? val : value;

	const handleInput = (event) => {
		const input = event.detail.value;
		setValue(input);
		if (onChange) onChange(event);
		if (getValue) getValue(input);
	};

	return (
		<WbInput
			id={setId}
			name={name}
			className={className}
			type={password ? 'password' : setType}
			value={currentValue}
			disabled={disabled || undefined}
			onWbinput={handleInput}
			data-testid={testId}
			special-action-label={password ? 'Toggle password visibility' : undefined}
		>
			<WbText slot="label" size="s">
				{message || label}
			</WbText>
		</WbInput>
	);
}

export default VimdtInput;
